var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgError = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.167 11.501h1.667v1.667H8.167v-1.667Zm0-6.666h1.667v5H8.167v-5ZM8.992.668C4.392.668.667 4.401.667 9.001s3.725 8.334 8.325 8.334c4.608 0 8.342-3.734 8.342-8.334S13.6.668 8.992.668Zm.008 15a6.665 6.665 0 0 1-6.666-6.667A6.665 6.665 0 0 1 9 2.335 6.665 6.665 0 0 1 15.667 9 6.665 6.665 0 0 1 9 15.668Z",
  fill: "#AE0000"
})));
export default SvgError;